// store/user.js
import router from "../../router";
import conexionSocket, { bindUserToSocket } from "@/composables/conexionSocket.js";

// Función para generar un identificador único del dispositivo basado en sus características
function generarIdDispositivoUnico() {
  // Recopilamos características únicas del dispositivo
  const userAgent = navigator.userAgent;
  const plataforma = navigator.platform;
  const resolucion = `${window.screen.width}x${window.screen.height}`;
  const colorDepth = window.screen.colorDepth;
  const pixelRatio = window.devicePixelRatio || 1;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const idioma = navigator.language;
  const procesadores = navigator.hardwareConcurrency || 'desconocido';
  
  // Combinamos todas las características en una cadena única
  const caracteristicasUnicas = [
    userAgent,
    plataforma,
    resolucion,
    colorDepth,
    pixelRatio,
    timezone,
    idioma,
    procesadores
  ].join('|');
  
  // Generamos un hash simple a partir de la cadena
  let hash = 0;
  for (let i = 0; i < caracteristicasUnicas.length; i++) {
    const char = caracteristicasUnicas.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convertir a entero de 32 bits
  }
  
  // Convertimos el hash a una cadena hexadecimal y nos aseguramos que sea positivo
  return `dispositivo_${Math.abs(hash).toString(16)}`;
}

const state = () => ({
  isLoggedIn: false,
  datosUsuario: {},
});

const getters = {
  loginState: state => state.isLoggedIn,
  datosUser: state => state.datosUsuario,
};

const mutations = {
  login(state, payload) {
    state.isLoggedIn = true;
    state.datosUsuario = payload;

    if (router.currentRoute.name === "Login") {
      router.push("/").catch(err => console.error(err));
    }
  },

  setDatosUsuario(state, payload) {
    state.datosUsuario = { ...state.datosUsuario, ...payload };
  },

  logout(state) {
    state.isLoggedIn = false;
    localStorage.removeItem("token");
    localStorage.removeItem("id_caja");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("recordar_sesion");
    sessionStorage.removeItem("sesion_activa");
    if (router.currentRoute.name !== "Login") {
      router.push("/login");
    }
  },
};

const actions = {
  async login({ commit, dispatch }, userData) {
    try {
      // Generar y guardar el ID único del dispositivo
      const idDispositivo = generarIdDispositivoUnico();
      
      // Guardar el ID en localStorage
      localStorage.setItem('id_dispositivo_unico', idDispositivo);
      
      // Añadir el ID del dispositivo a los datos del usuario
      userData.idDispositivo = idDispositivo;

      commit('login', userData);

    } catch (error) {
      console.error('Error al inicializar ubicación o generar ID de dispositivo:', error);
      // Si falla la ubicación o la generación del ID, igual hacemos login pero notificamos
      commit('login', userData);
    }

    // El socket se conecta al importar el módulo, antes de que exista sesión,
    // así que el bindUser del 'connect' se emite sin usuario/token.
    // Re-emitir acá cubre login inicial y re-login con otro usuario (card #391).
    bindUserToSocket();

    // #385: effective actions for the new permission system. Fire-and-forget:
    // navigation never waits for it and the store swallows 503 (fail-open).
    dispatch("permisos/cargarMisAcciones", undefined, { root: true }).catch(() => {});
  },

  async logout({ commit, state }) {
    try {
      // Emitir evento de logout al socket
      if (state.datosUsuario.id_usuario) {
        conexionSocket.emit('logout', {
          id_usuario: state.datosUsuario.id_usuario
        });
      }

      // Esperar a que se complete la desconexión
      await new Promise(resolve => {
        conexionSocket.once('logout-completed', resolve);
        
        // Timeout por si no recibimos respuesta
        setTimeout(resolve, 1000);
      });

      // Desconectar socket
      conexionSocket.disconnect();

      // Proceder con el logout local
      commit("logout");
      
    } catch (error) {
      console.error('Error durante logout:', error);
      // Aún así procedemos con el logout local
      commit("logout");
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};